import avatar from '../../assets/images/avatar.svg'
import {
  AvatarStyles,
  CardTourStyles,
  CardTourWithAvatarStyles,
} from './styles'

const TourPredicoesDetails = [
  {
    title: <AvatarStyles src={avatar} alt="avatar" />,
    content: (
      <CardTourWithAvatarStyles marginTop="40px">
        <span>Saiba como dar baixa no produto!</span>
        <br />
        <br />
        <strong> Vamos lá!</strong>
      </CardTourWithAvatarStyles>
    ),
    target: '#saudacaoPredicaoDetail',
    placement: 'center',
  },
  {
    content: (
      <CardTourStyles marginTop="-20px">
        <p>Realizar baixa</p>
        <span>
          Conforme os pedidos dos materiais forem efetuados, é possivel dar
          baixa no produto para informar ao sistema que ocorreu a reposição do
          material. Para isso, clique no checkbox e confirme a baixa do produto.
        </span>
      </CardTourStyles>
    ),
    target: '#darBaixa',
    placement: 'left-fixed',
  },

  {
    title: <AvatarStyles src={avatar} alt="avatar" />,
    content: (
      <CardTourWithAvatarStyles marginTop="40px">
        <strong>Pronto!</strong>
        <br />
        <br />
        <span>Um passo a frente no follow up dos seus clientes!</span>
      </CardTourWithAvatarStyles>
    ),
    target: '#finalizacaoPredicao',
    placement: 'center',
  },
]
export default TourPredicoesDetails
